import { useContext } from "react";
import { OrderInvitationContext } from "../providers/OrderInvitationProvider";
import { OrderInvitationContextType } from "../types";

export const useOrderInvitation = (): OrderInvitationContextType => {
  const context = useContext(OrderInvitationContext);

  if (!context) {
    throw new Error(
      "useOrderInvitation must be used within an OrderInvitationProvider"
    );
  }

  return context;
};
